import routeHandler from './routes';
import MODULE_ID from './moduleId';

const module = {
  moduleType: 'News',
  api: 'news',
  moduleId: MODULE_ID,
  routeHandler,
};
export default module;
